import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => (
  <footer className="w-full bg-background border-t border-border mt-12 py-8">
    <div className="max-w-3xl mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div>
          <h3 className="font-semibold mb-3 text-primary">Surge Banking</h3>
          <p className="text-sm text-muted-foreground">Secure, fast, and reliable mobile banking.</p>
        </div>
        <div>
          <h4 className="font-semibold text-sm mb-3">Support</h4>
          <a href="mailto:surgebanking@aol.com" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
            <Mail size={16} /> surgebanking@aol.com
          </a>
        </div>
        <div>
          <h4 className="font-semibold text-sm mb-3">Legal</h4>
          <ul className="space-y-1 text-sm text-muted-foreground">
            <li><a href="#" className="hover:text-primary transition-colors">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-primary transition-colors">Terms of Service</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border pt-6 text-center text-sm text-muted-foreground">
        <p>&copy; 2026 Surge Banking. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
